import { createSlice, current } from "@reduxjs/toolkit";

import moment from "moment";
const initialState = {
  userOrder: [],
  isLoading: false,
  error: "",
  temp: [],
};

const userSlice = createSlice({
  name: "userOrder",
  initialState,
  reducers: {
    userOrderPending: (state) => {
      state.isLoading = true;
    },
    userOrderSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.userOrder = payload;
      state.temp = payload;
      state.error = "";
    },
    userOrderFail: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    updateDateOrderSuccess: (state, { payload }) => {
      state.isLoading = false;
      console.log(payload);
      if (payload) {
        const temp = state.userOrder.findIndex((x) => x._id === payload.id);
        // console.log(current(temp), "value");
        console.log(temp);
        if (temp > -1) {
          state.userOrder[temp].booking_date_timestamp = payload.booking_date;
        }
      }
    },
    searchOrderSuccess: (state, { payload }) => {
      // console.log(payload);
      let data = state.temp;
      let value;

      if (payload.date_register_0 && payload.date_register_1) {
        data = data.filter(
          (x) =>
            moment(x.booking_date).unix() <= payload.date_register_1 &&
            moment(x.booking_date).unix() >= payload.date_register_0
        );
      }
      if (payload.date_verify_0 && payload.date_verify_1) {
        data = data.filter(
          (x) =>
            moment(x.confirm_date).unix() <= payload.date_verify_1 &&
            moment(x.confirm_date).unix() >= payload.date_verify_0
        );
      }

      if (payload.vaccine_id) {
        console.log(payload.vaccine_id);
        data = data.filter((x) => x.vaccine_id === payload.vaccine_id);
      }

      let status = [0, 1, 2, 3, 4];

      if (status.includes(payload.status)) {
        data = data.filter((x) => x.status === payload.status);
      }

      // console.log(current(data), "value");

      // console.log("asssssssss", current(value));
      // state.userOrder = value;

      // value = data.filter((x) => x.vaccine_id === payload.vaccine_id);
      // value = data.filter((x) => x.status === payload.status);
      state.userOrder = data;
      state.isLoading = false;
      state.error = "";
    },
    resetOrderSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.userOrder = state.temp;
      state.error = "";
    },
    deleteOrderSuccess: (state, { payload }) => {
      // console.log("payload", payload.order_id);
      const index = state.userOrder.findIndex(
        (x) => x._id === payload.order_id
      );
      state.userOrder[index].status = 4;

      state.isLoading = false;
      state.temp = state.userOrder;
      // state.userOrder = state.temp;
      state.error = "";
    },
  },
});

const { reducer, actions } = userSlice;

export const {
  userOrderPending,
  userOrderSuccess,
  userOrderFail,
  searchOrderSuccess,
  resetOrderSuccess,
  deleteOrderSuccess,
  updateDateOrderSuccess,
} = actions;

export default reducer;
